export const combineClassnames = (...args: (string | undefined)[]) =>
  args.filter(Boolean).join(' ') || undefined
